import { useEffect, useRef } from "react";

export default function PhilosophySection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-charcoal-900 py-24 md:py-32 border-y border-dark-border">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl mx-auto text-center">
        <p className="reveal opacity-0 translate-y-4 transition-all duration-600 ease-out text-xs md:text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-8">
          Our Philosophy
        </p>
        <p className="reveal opacity-0 translate-y-4 transition-all duration-600 ease-out delay-150 font-serif text-2xl sm:text-3xl md:text-4xl lg:text-[2.75rem] text-charcoal-50 leading-relaxed md:leading-relaxed font-normal">
          In a world of compromise, your water should be the one thing you never
          settle on.&nbsp;
        </p>
      </div>
    </section>
  );
}